import React, { useState, forwardRef } from "react";
import { Zap, ArrowUpRight } from "lucide-react";
import { JobsContent, t } from "@/content/jobs";

const ProviderPitchCard = forwardRef(function ProviderPitchCard({ job, lang, T, onClick }, ref) {
  const [hover, setHover] = useState(false);
  return (
    <button
      ref={ref}
      type="button"
      onClick={() => onClick(job.slug)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        textAlign: "left", display: "flex", flexDirection: "column",
        padding: "28px 28px 24px", borderRadius: 20,
        backgroundColor: T.bgElev,
        border: `1px solid ${hover ? T.amber : T.border}`,
        transition: "all 200ms", cursor: "pointer", width: "100%"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
        <div style={{
          fontFamily: "ui-monospace, Menlo, monospace",
          fontSize: 10, letterSpacing: "0.16em", textTransform: "uppercase",
          color: T.textMute, fontWeight: 600
        }}>
          {t(job.department, lang)}
        </div>
        <span style={{
          display: "inline-flex", alignItems: "center", gap: 5,
          padding: "4px 9px", borderRadius: 999, fontSize: 10, fontWeight: 700,
          backgroundColor: T.amberSoft, color: T.amber,
          fontFamily: "ui-monospace, Menlo, monospace",
          letterSpacing: "0.04em", textTransform: "uppercase"
        }}>
          <Zap size={10} strokeWidth={2.5} />
          {t(JobsContent.ui.commission_badge, lang)}
        </span>
      </div>
      <h3 style={{
        fontSize: "1.375rem", fontWeight: 700, lineHeight: 1.15, letterSpacing: "-0.02em",
        color: T.text, margin: "0 0 10px"
      }}>
        {t(job.title, lang)}
      </h3>
      <p style={{ fontSize: 14, lineHeight: 1.55, color: T.textMute, margin: "0 0 18px" }}>
        {t(job.short_pitch, lang)}
      </p>
      <span style={{
        display: "inline-flex", alignItems: "center", gap: 5, fontSize: 13, fontWeight: 600,
        color: T.amber, paddingTop: 14, borderTop: `1px solid ${T.borderSubtle}`,
        transform: hover ? "translateX(3px)" : "translateX(0)", transition: "transform 180ms"
      }}>
        {t(JobsContent.ui.join_network, lang)}
        <ArrowUpRight size={15} strokeWidth={2.5} />
      </span>
    </button>
  );
});

export default ProviderPitchCard;
